import { WarrantyType } from "../binders/binders.types";


export const StatusForBroker = {
	NEW: "Nouveau",
	TO_ANALYZE: "A analyser",
	TO_SIGN: "A signer",
	PROGRESS: "En cours",
	CANCELLED: "Résilié",
	TO_RENEW: "A renouveler",
	ACTIVE: "Actif",
} as const;

export type BrokerStatus = "NEW" | "TO_ANALYZE" | "TO_SIGN" | "PROGRESS" | "CANCELLED"  | "TO_RENEW" | "ACTIVE";

const statusForCategory = ["REGISTERED", "NOT_REGISTERED"] as const;
export type StatusForCategory = (typeof statusForCategory)[number];

export type StatusForBroker = keyof typeof StatusForBroker;

export type BrokerCategory = {
	category: string;
	status: StatusForCategory;
	registrationDate: string;
	categoryDeletionDate?: string;
	fundCollection: boolean;
	mandants: string;
};

export type OneBroker = {
	oriasNumber: string;
	categories: BrokerCategory[];
	ref: string;
	siren: string;
	socialReasons: string;
	city: string;
	streetName: string;
	streetNumber: string;
	postalCode: string;
	partnershipDate?: string;
	network?: {
		attachedToNetwork: boolean;
		networkName: string;
	};
	group?: {
		attachedToGroup: boolean;
		sirenGroup: string;
		companyNameGroup: string;
	};
	entities: string[];
	emailRoutingUuid: string;
	status: StatusForBroker;
	manager: {
		firstname: string;
		lastname: string;
		email: string;
		phone: string;
		isUser: boolean;
	};
	graphicCharter?: {
		color?: string;
		logo?: {
			name: string;
			key: string;
			bucket: string;
			mimeType: string;
		};
	};
	canGenerateApiKeys?: boolean;
};

export type AccessibleProduct = {
	id: number;
	name: string;
	authorized: boolean;
	commission: string;
	minCommission: string;
	maxCommission: string;
	isReunionDepartmentAuthorized: boolean;
	brokerDetailsId: number | null;
	binderId: number | null;
	warrantyType: WarrantyType | null;
	gfaProduct: boolean | null;
};
export interface BrokerAccounting {
	id: number;
	iban?: string | null;
	bic?: string | null;
	managerFirstname?: string | null;
	managerLastname?: string | null;
	managerEmail?: string | null;
	managerPhone?: string | null;
}
